/**
 * A place to store all HiveWatch colors so that they can easily be reused, and we can avoid using colors that
 * slightly vary from page to page.
 */
export const Colors = {
  hiveWatchDarkBlue: '#303D5D',
  white: '#FFFFFF',
  black: '#000000',
  gray300: 'gray.300',
  // As of now labels also use a 50% opacity to achieve their gray-ish shade
  formLabel: '#2d2e41',
}
